import { CliError } from "../cli/cli-error";
import { VERSION } from "../version/version-constants";
import { CLI_ERROR_CODES } from "@/lib/shared/errors-constants";
import type { Predicate } from "@/lib/predicate/predicate";
import { read } from "@/lib/read/read";

/**
 * Check a 2xx payload before the command destructures it. The client casts
 * responses to the router's types — a compile-time promise about a server that
 * may be older or newer than this binary. When it did not hold, the first
 * property read threw `Cannot read properties of undefined`.
 */
export function expectShape<T>(
  payload: unknown,
  endpoint: string,
  requirements: Record<string, Predicate>,
): T {
  for (const [field, predicate] of Object.entries(requirements)) {
    if (!predicate(read(payload, field))) {
      throw new CliError(
        `${endpoint} returned a payload this CLI does not understand: "${field}" is missing or has the wrong type. hepha ${VERSION} may be out of step with the platform — try \`npm install -g @impulselab/hepha\`.`,
        1,
        { code: CLI_ERROR_CODES.API_SCHEMA_MISMATCH },
      );
    }
  }

  return payload as T;
}
